<ion-content class="admin-login-content">
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <div class="logo-container">
          <ion-icon name="shield-checkmark" class="admin-icon"></ion-icon>
        </div>
        <h1 class="login-title">Admin Portal</h1>
        <p class="login-subtitle">Sign in to access the dashboard</p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <div class="form-group">
          <label for="email" class="form-label">Email Address</label>
          <div class="input-wrapper" [class.error]="emailControl?.invalid && emailControl?.touched">
            <ion-icon name="mail-outline" class="input-icon"></ion-icon>
            <input
              type="email"
              id="email"
              formControlName="email"
              placeholder="Enter your email"
              class="form-input"
            />
          </div>
          <div class="error-message" *ngIf="emailControl?.invalid && emailControl?.touched">
            <span *ngIf="emailControl?.errors?.['required']">Email is required</span>
            <span *ngIf="emailControl?.errors?.['email']">Please enter a valid email</span>
          </div>
        </div>

        <div class="form-group">
          <label for="password" class="form-label">Password</label>
          <div class="input-wrapper" [class.error]="passwordControl?.invalid && passwordControl?.touched">
            <ion-icon name="lock-closed-outline" class="input-icon"></ion-icon>
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              placeholder="Enter your password"
              class="form-input"
            />
            <ion-icon
              [name]="showPassword ? 'eye-off-outline' : 'eye-outline'"
              class="toggle-password"
              (click)="togglePassword()"
            ></ion-icon>
          </div>
          <div class="error-message" *ngIf="passwordControl?.invalid && passwordControl?.touched">
            <span *ngIf="passwordControl?.errors?.['required']">Password is required</span>
            <span *ngIf="passwordControl?.errors?.['minlength']">Password must be at least 6 characters</span>
          </div>
        </div>

        <div class="error-banner" *ngIf="errorMessage">
          <ion-icon name="alert-circle-outline"></ion-icon>
          <span>{{ errorMessage }}</span>
        </div>

        <button type="submit" class="submit-btn" [disabled]="isLoading">
          <ion-spinner name="crescent" *ngIf="isLoading"></ion-spinner>
          <span *ngIf="!isLoading">Sign In</span>
        </button>
      </form>

      <div class="login-footer">
        <a routerLink="/home" class="back-link">
          <ion-icon name="arrow-back-outline"></ion-icon>
          <span>Back to Home</span>
        </a>
      </div>
    </div>
  </div>
</ion-content>

